import gql from "graphql-tag";
export const slugValue = gql`
  fragment SlugValue on OnlineRates {
    toCurrency
    rate
  }
`;

export const currencyrateFragment = gql`
  ${slugValue}
  fragment CurrencyrateFragment on Currencyrate {
    id
    slug {
      ...SlugValue
    }
    name
    code
    symbol
    rate
    displayFormat
    conversionMethod
    updateDate
    displayOrder
    isPublished
  }
`;

export const currencyrateDetailsFragment = gql`
  ${slugValue}
  fragment CurrencyrateDetailsFragment on Currencyrate {
    id
    slug {
      ...SlugValue
    }
    name
    symbol
    rate
    code
    conversionMethod
    isPrimaryStoreCurrency
    isPrimaryExchangeRateCurrency
    isPublished
    displayOrder
    displayFormat
    updateDate
  }
`;
